// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.DisconnectExtensions = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DisconnectExtensions = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var DisconnectExtensions = _exports.DisconnectExtensions = function DisconnectExtensions(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.625 13.749C4.63044 13.749 3.67661 13.3539 2.97335 12.6507C2.27009 11.9474 1.875 10.9936 1.875 9.99902C1.875 9.00446 2.27009 8.05063 2.97335 7.34737C3.67661 6.64411 4.63044 6.24902 5.625 6.24902H8.125M14.375 6.24902C15.3696 6.24902 16.3234 6.64411 17.0267 7.34737C17.7299 8.05063 18.125 9.00446 18.125 9.99902C18.125 10.9936 17.7299 11.9474 17.0267 12.6507C16.3234 13.3539 15.3696 13.749 14.375 13.749H11.875M5.625 9.99902H7.5M14.375 9.99902H12.5M13 2.99902L7 16.999",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
